import { render, staticRenderFns } from "./bp-submit-detail.vue?vue&type=template&id=0ff5855f&"
import script from "./bp-submit-detail.vue?vue&type=script&lang=ts&"
export * from "./bp-submit-detail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports